import { render } from "./ModalEditTender.vue?vue&type=template&id=911cf7f0&scoped=true"
import script from "./ModalEditTender.vue?vue&type=script&lang=js"
export * from "./ModalEditTender.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-911cf7f0"

export default script